import moment from "moment";

export const dutyColumns = [
  {
    title: '值班日期',
    key: 'dutyDate',
    align: 'center',
    render: (h, params) => {
      return h('div', [
        h('span', moment(params.row.dutyDate).format('YYYY-MM-DD'))
      ])
    }
  },
  { title: '区县', key: 'countyName', align: 'center' },
  { title: '值班类型', key: 'post', align: 'center' },
  { title: '值班人员', key: 'whiteDutyPersonnel', align: 'center' },
  { title: '值班电话', key: 'whiteDutyIphone', align: 'center' },
  // { title: '值班人员手机号', key: 'whiteIphone', align: 'center' },
  // 操作列
  { title: '操作', slot: 'action', align: 'center', width: 200 }
]
